import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import PeinturePage from './pages/PeinturePage';
import RavalementPage from './pages/RavalementPage';
import CouverturePage from './pages/CouverturePage';
import ContactPage from './pages/ContactPage';
import NotFoundPage from './pages/NotFoundPage';
import MentionsLegalesPage from './pages/MentionsLegalesPage';
import PolitiqueConfidentialitePage from './pages/PolitiqueConfidentialitePage';
import CGUPage from './pages/CGUPage';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="peinture-interieure" element={<PeinturePage />} />
            <Route path="ravalement" element={<RavalementPage />} />
            <Route path="couverture" element={<CouverturePage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="mentions-legales" element={<MentionsLegalesPage />} />
            <Route path="politique-de-confidentialite" element={<PolitiqueConfidentialitePage />} />
            <Route path="cgu" element={<CGUPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </div>
    </Router>
  );
}

export default App;
